import { useEffect } from "react"

function useOutsideDetector(ref, callback, deps = []) {
  useEffect(
    () => {
      /**
       * Run callback if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          callback()
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside)

      // Unbind the event listener on clean up
      return () => document.removeEventListener("mousedown", handleClickOutside)
    },
    [ref, ...deps],
  )
}

export default useOutsideDetector
